import styled, { css } from "styled-components";

import Paper from "components/Layout/Paper";

import { COLORS } from "constants/colorScheme";
import { MEDIA_QUERIES } from "constants/layout";

const CARD_HEIGHT = 120;

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  background-color: ${COLORS.WHITE};
  border-radius: 8px;
  margin-bottom: 20px;
`;

export const ImageContainer = styled.div`
  min-width: 280px;
  min-height: ${CARD_HEIGHT}px;
  background-image: url(${({ image }: { image: string }) => image});
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  border-radius: 8px;
  margin-top: 20px;
  margin-bottom: 20px;
`;

export const DetailsContainer = styled(Paper)`
  display: flex;
  justify-content: space-between;
  height: ${CARD_HEIGHT}px;
  width: 100%;
  padding: 24px;
  ${MEDIA_QUERIES.SMALL_DESKTOP} {
    padding: 24px 12px;
  }
`;

export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const TitleWrapper = styled.div`
  margin-left: 6px;
  margin-bottom: 8px;
  cursor: "pointer";
`;

export const SubTitleWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-left: 6px;
  gap: 6px;
  margin-bottom: 8px;
`;

export const BottomControlsContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  ${({ marginTop }: { marginTop?: string }) =>
    css`
      margin-top: ${marginTop};
    `}
`;

export const ControlWrapper = styled.div`
  &:not(:last-child) {
    margin-right: 40px;
  }
  ${MEDIA_QUERIES.SMALL_DESKTOP} {
    &:not(:last-child) {
      margin-right: 16px;
    }
  }
`;

export const MenuContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  min-width: 236px;
`;

export const MenuContentWrapper = styled.div`
  margin-right: 40px;
`;

export const Menu = styled.div`
  display: flex;
  & path,
  & use {
    fill: ${COLORS.BLACK_50};
  }
`;
